import type { AdminUserListQuery } from '@/api/admin-api'

/**
 * Query keys for the administration module.
 *
 * The user list key carries the whole query object, the same discipline `customerKeys` and
 * `groupKeys` keep — a changed filter is a new cache entry rather than a mutation of an existing
 * one, which is what lets a page of results survive while the next page is fetched.
 *
 * Roles and the permission catalogue have no list-of-lists shape to key by query: `listRoles` and
 * `listPermissions` each take no parameters, so there is exactly one cache entry for each.
 */
export const adminKeys = {
  all: ['admin'] as const,
  users: () => [...adminKeys.all, 'users'] as const,
  userLists: () => [...adminKeys.users(), 'list'] as const,
  userList: (query: AdminUserListQuery) => [...adminKeys.userLists(), query] as const,
  userDetails: () => [...adminKeys.users(), 'detail'] as const,
  userDetail: (userId: string) => [...adminKeys.userDetails(), userId] as const,
  roles: () => [...adminKeys.all, 'roles'] as const,
  permissions: () => [...adminKeys.all, 'permissions'] as const,
}
